import { useTranslation } from 'react-i18next'

/**
 * Tamarra Formalités — info grid + cancellation scale + acknowledgements.
 * content: { title, body, blocks:[{h,items,visa?}], cancelRows:[[when,penalty]] }
 */
const TamarraFormalitesStep = ({
  ack,
  onAck,
  error = false,
  kind = 'transfer',
  content = null,
  cancelRows: cancelRowsProp = [],
}) => {
  const { t } = useTranslation()

  const fallbackCopy =
    kind === 'spa'
      ? {
          title: t('tamarraBooking.formalites.spaTitle', {
            defaultValue: 'Avant de confirmer votre soin',
          }),
          body: t('tamarraBooking.formalites.spaBody', {
            defaultValue:
              'Merci de prendre connaissance des conditions d’annulation et des consignes santé.',
          }),
        }
      : kind === 'carte'
        ? {
            title: t('tamarraBooking.formalites.carteTitle', {
              defaultValue: 'Avant de confirmer votre carte',
            }),
            body: t('tamarraBooking.formalites.carteBody', {
              defaultValue:
                'Vérifiez la période de validité et les conditions d’accès.',
            }),
          }
        : kind === 'circuit'
          ? {
              title: t('tamarraBooking.formalites.circuitTitle', {
                defaultValue: 'Avant de confirmer votre circuit',
              }),
              body: t('tamarraBooking.formalites.circuitBody', {
                defaultValue:
                  'Lisez ces points : certains demandent des démarches avant le départ.',
              }),
            }
          : {
              title: t('tamarraBooking.formalites.transferTitle', {
                defaultValue: 'Avant de confirmer votre transfert',
              }),
              body: t('tamarraBooking.formalites.transferBody', {
                defaultValue:
                  'Présentez-vous à l’heure indiquée. L’annulation suit la grille de l’offre.',
              }),
            }

  const title = content?.title || fallbackCopy.title
  const body = content?.body || fallbackCopy.body
  const blocks = Array.isArray(content?.blocks) ? content.blocks : []
  const cancelRows =
    Array.isArray(content?.cancelRows) && content.cancelRows.length
      ? content.cancelRows
      : cancelRowsProp
  const hasCancel = cancelRows.length > 0

  return (
    <div className="tamarra-formalites">
      <div className="tamarra-sec-intro">
        <span className="tamarra-label">
          {t('tamarraBooking.formalites.stepLabel', {
            defaultValue: 'Étape 2 sur 4 · Consignes et formalités',
          })}
        </span>
        <h3>{title}</h3>
        <p>{body}</p>
      </div>

      {blocks.length ? (
        <div className="tamarra-info-grid">
          {blocks.map((block) => (
            <section key={block.h} className="tamarra-info">
              <h4>{block.h}</h4>
              <ul>
                {(block.items || []).map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
              {block.visa ? (
                <p className="tamarra-visa">
                  <span className="tamarra-chip warn">
                    {t('tamarraBooking.formalites.toCheck', { defaultValue: 'À vérifier' })}
                  </span>{' '}
                  {block.visa}
                </p>
              ) : null}
            </section>
          ))}

          {hasCancel ? (
            <section className="tamarra-info wide">
              <h4>
                {t('tamarraBooking.formalites.cancelTitle', {
                  defaultValue: "Barème d'annulation",
                })}
                <span className="tamarra-chip">
                  {t('tamarraBooking.formalites.cancelChip', { defaultValue: 'Produit' })}
                </span>
              </h4>
              <table className="tamarra-cancel-table">
                <tbody>
                  {cancelRows.map(([when, penalty]) => (
                    <tr key={`${when}-${penalty}`}>
                      <td>{when}</td>
                      <td>{penalty}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </section>
          ) : null}
        </div>
      ) : hasCancel ? (
        <section className="tamarra-info wide">
          <h4>
            {t('tamarraBooking.formalites.cancelTitle', {
              defaultValue: "Barème d'annulation",
            })}
            <span className="tamarra-chip">
              {t('tamarraBooking.formalites.cancelChip', { defaultValue: 'Produit' })}
            </span>
          </h4>
          <table className="tamarra-cancel-table">
            <tbody>
              {cancelRows.map(([when, penalty]) => (
                <tr key={`${when}-${penalty}`}>
                  <td>{when}</td>
                  <td>{penalty}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      ) : null}

      <div className="tamarra-ack-list">
        <label className="tamarra-ack">
          <input
            type="checkbox"
            checked={!!ack[1]}
            onChange={(e) => onAck(1, e.target.checked)}
          />
          <span>
            {t('tamarraBooking.formalites.ack2Cancel', {
              defaultValue:
                'J’accepte les conditions de vente et le barème d’annulation.',
            })}
          </span>
        </label>
      </div>

      {error ? (
        <div className="tamarra-banner" role="alert">
          {t('tamarraBooking.formalites.ackError', {
            defaultValue: 'Cochez la case pour continuer.',
          })}
        </div>
      ) : null}
    </div>
  )
}

export default TamarraFormalitesStep
